export default __webpack_public_path__ + "static/media/zigzag.8ce16498.jpg";